<div class="host">
    <div class="d-flex flex-column align-items-center">
        <div><img alt="company logo" class="page-image" src="assets/img/Illustration_entreprise_resultat.png" /></div>
        <div class="raison-sociale lg-text">{{ projectName }}</div>
    </div>
</div>
